import * as React from "react"
import { Box } from "@mui/material"
import { SwitchSeeker } from "@ui-seeker/core"

import { useAdminBrandActions } from "../../@hooks"


export default function switchColumn(field, label) {

    return [{
        name: field,
        label: label,
        options: {
            display: 'excluded',
            customBodyRender: value => value ? "Yes" : "No"
        }
    }, {
        name: field,
        label: label,
        options: {
            filter: false,
            setCellHeaderProps: () => ({ style: { textAlign: "center", minWidth: 50 } }),
            setCellProps: () => ({ style: { textAlign: "center" } }),
            customBodyRowRenderLite: (value, row) => <SwitchCell value={value} row={row} field={field} />
        }
    }]
}

const SwitchCell = ({ value, row={}, field }) => {
    const { updateSwitch, isLoading } = useAdminBrandActions(row)

    return <Box display="flex" justifyContent="center" alignItems="center" className={isLoading ? 'is-loading' : ''}>
        <SwitchSeeker
            disabled={isLoading}
            formControlProps={{ sx: { margin: '0 auto' } }}
            checked={!!value}
            onChange={() => updateSwitch(field, !value)}
        />
    </Box>  
}